import axios from 'axios';
import { getToken } from '../../services/tokenService';

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const sp = {
  get: (path) => axios.get(`${API}/api/sponsor${path}`, auth()),
  post: (path, body) => axios.post(`${API}/api/sponsor${path}`, body, auth()),
  patch: (path, body) => axios.patch(`${API}/api/sponsor${path}`, body, auth()),
  del: (path) => axios.delete(`${API}/api/sponsor${path}`, auth()),
  upload: (path, formData) =>
    axios.post(`${API}/api/sponsor${path}`, formData, { headers: { ...auth().headers } }),
};

export { API };
